export const baseURL = 'https://tsj-admin.xrzww.com/';
export const ossURL = 'https://oss.xrzww.com/';
export const siteURL = 'https://www.tuishujun.com';
export const siteName = '推书君';
export const siteShortName = '推书';
